<template>
  <div
    class="accordion__item"
    :class="[itemClass, isOpenItem && 'accordion__item--no-close']"
    @click="openAnswer"
  >
    <template v-if="hasMicroData">
      <div
        class="accordion__header"
      >
        <h4
          class="accordion__question"
          itemprop="name"
          @click.stop="toggleAnswer"
          v-html="title"
        ></h4>
        <button
          v-if="!isOpenItem"
          class="accordion__toggle-button"
          aria-label="Закрыть/открыть"
          @click.stop="toggleAnswer"
        ></button>
      </div>
      <transition
        @enter="enter"
        @leave="leave"
      >
        <div
          v-show="isOpened"
          class="accordion__content"
          itemscope
          itemprop="acceptedAnswer"
          itemtype="https://schema.org/Answer"
        >
          <slot></slot>
        </div>
      </transition>
    </template>
    <template v-else>
      <div class="accordion__header">
        <h4
          class="accordion__question"
          @click.stop="toggleAnswer"
          v-html="title"
        ></h4>
        <button
          v-if="!isOpenItem"
          class="accordion__toggle-button"
          aria-label="Закрыть/открыть"
          @click.stop="toggleAnswer"
        ></button>
      </div>
      <transition
        @enter="enter"
        @leave="leave"
      >
        <div
          v-show="isOpened"
          class="accordion__content"
        >
          <slot></slot>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SAccordionItem',
  props: {
    title: {
      type: String,
      required: true
    },
    answer: {
      type: String,
      default: ''
    },
    hasMicroData: {
      type: Boolean,
      default: false
    },
    isOpenItem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpened: this.isOpenItem
    }
  },
  computed: {
    itemClass() {
      return this.isOpened
        ? 'accordion__item--opened'
        : 'accordion__item--closed'
    }
  },
  methods: {
    openAnswer() {
      this.isOpened = true
    },
    toggleAnswer() {
      this.isOpened = this.isOpenItem
        ? true
        : !this.isOpened
    },
    enter(target, done) {
      this.$velocity(target, 'slideDown', {duration: 300}, {complete: done})
    },
    leave(target, done) {
      this.$velocity(target, 'slideUp', {duration: 200}, {complete: done})
    }
  }
}
</script>

<style lang="scss">
.accordion__item--no-close {
  .accordion__question:hover {
    color: $primary !important;
    cursor: default;
  }
}

.accordion__item--closed {
  flex-direction: column;
}

.accordion__item {
  padding: 24px 64px 24px 0;
  border-top: 1px solid $grayBorder;
  display: flex;
  position: relative;

  @media (max-width: $breakpoint-lg) {
    padding-right: 0;
    flex-direction: column;
  }

  @media (max-width: $breakpoint-md) {
    padding: 16px 0;
  }

  &:first-of-type {
    border-top: none;
  }

  &:hover {
    cursor: pointer;
  }
}

.accordion__item--opened:hover {
  cursor: default;
}

.accordion__header {
  width: 100%;
  padding-right: 40px;

  transition: width 0s 0.05s;

  @media (max-width: $breakpoint-lg) {
    height: auto !important;
    width: 100%;
    padding-right: 64px;
  }

  @media (max-width: $breakpoint-md) {
    padding-right: 28px;
  }
}

.accordion__item--opened .accordion__header {
  width: calc(100% / 9 * 4 - 30px);

  transition: width 0s;

  @media (max-width: $breakpoint-lg) {
    width: 100%;
    padding-right: 64px;
  }

  @media (max-width: $breakpoint-md) {
    padding-right: 28px;
  }
}

.accordion__question {
  margin-bottom: 0;
  color: $primary;
  transition: color 0.2s;

  @media (max-width: $breakpoint-lg) {
    position: static;
    padding-right: 0;
  }

  .accordion__item:hover & {
    color: $secondary;

    @media (max-width: $breakpoint-lg) {
      color: $primary !important;
      cursor: default;
    }
  }

  .accordion__item--opened:hover & {
    color: $primary;
  }
}

.accordion__question:hover {
  color: $secondary !important;
  cursor: pointer;

  @media (max-width: $breakpoint-lg) {
    color: $primary !important;
    cursor: default;
  }
}

.accordion__content {
  margin-top: -24px;
  overflow: hidden;
  margin-left: auto;
  opacity: 0;
  transition: opacity 0s ease;

  width: calc(100% / 9 * 5 + 30px);

  @media (max-width: $breakpoint-lg) {
    margin-top: 24px;
    opacity: 1;
    margin-left: 0;
    width: 75%;
  }

  @media (max-width: $breakpoint-md) {
    margin-top: 16px;
    width: calc(100% / 6 * 5 + 16px);
  }

  ul, ol {
    margin-bottom: 1em;
  }

  *:last-child {
    margin-bottom: 0;
  }

}

.accordion__item--opened .accordion__content {
  margin-top: 0;
  opacity: 1;

  transition: opacity 0.3s ease;

  @media (max-width: $breakpoint-lg) {
    margin-top: 24px;
  }

  @media (max-width: $breakpoint-md) {
    margin-top: 16px;
  }
}

.accordion__toggle-button {
  position: absolute;
  top: 27px;
  right: 0;

  display: block;
  padding: 0;
  width: 24px;
  height: 24px;

  border: none;
  background: transparent;
  cursor: pointer;

  transition: 0.5s ease-in-out;

  outline: none;

  &:before,
  &:after {
    content: '';

    position: absolute;
    top: 11px;
    left: 0;

    width: 24px;
    height: 2px;
    background-color: $primary;

    display: block;
    border-radius: 9px;
    opacity: 1;

    transition: 0.25s ease-in-out;

    @media (max-width: $breakpoint-md) {
      width: 16px;
    }

    .accordion__item:hover & {
      background-color: $secondary;

      @media (max-width: $breakpoint-lg) {
        background-color: $primary !important;
        cursor: default;
      }
    }

    .accordion__item--opened:hover & {
      background-color: $primary;
    }
  }

  @media (max-width: $breakpoint-md) {
    width: 16px;
    height: 16px;
    top: 16px;
  }
}

.accordion__toggle-button:hover:before,
.accordion__toggle-button:hover:after {
  background-color: $secondary !important;

  @media (max-width: $breakpoint-lg) {
    background-color: $primary !important;
    cursor: default;
  }
}

.accordion__toggle-button:before {
  transform: rotate(90deg);
}

.accordion__toggle-button:after {
  transform: rotate(180deg);
}

.accordion__item--opened .accordion__toggle-button:before,
.accordion__item--opened .accordion__toggle-button:after {
  transform: rotate(0deg);
}
</style>